"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeProjectionExpression = void 0;
var tslib_1 = require("tslib");
/**
 * Convert the supplied projection expression to the string format
 * expected by DynamoDB, substituting all attribute paths using the
 * provided ExpressionAttributes object.
 */
function serializeProjectionExpression(projection, attributes) {
    var e_1, _a;
    var serialized = [];
    try {
        for (var projection_1 = tslib_1.__values(projection), projection_1_1 = projection_1.next(); !projection_1_1.done; projection_1_1 = projection_1.next()) {
            var projected = projection_1_1.value;
            serialized.push(attributes.addName(projected));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (projection_1_1 && !projection_1_1.done && (_a = projection_1.return)) _a.call(projection_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return serialized.join(', ');
}
exports.serializeProjectionExpression = serializeProjectionExpression;
